import styled from "styled-components";

import { colors } from "@/Utils";

const Span = styled.span`
  display: inline-block;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  margin-left: ${(props) => (props.mLeft ? props.mLeft : "8px")};
  font-size: ${(props) => (props.fSize ? props.fSize : "10px")};
`;

const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  //   margin-bottom: ${(props) => (props.mBottom ? props.mBottom : "17px")};
`;

const Icon = styled.svg`
  fill: none;
  stroke: ${colors.black};
  stroke-width: 2px;
`;
// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const LabelWrap = styled.label`
  margin-bottom: ${(props) => (props.mBottom ? props.mBottom : "14px")};
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const StyledCheckbox = styled.div`
  display: inline-block;
  width: 12px;
  height: 12px;
  background: ${(props) => (props.checked ? `${colors.white}` : `${colors.white}`)}
  transition: all 150ms;

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 1px ${colors.lightGreen};
  }

  ${Icon} {
    visibility: ${(props) => (props.checked ? "visible" : "hidden")}
  }
`;

const Checkbox = ({ className, checked, onChange, id, label, ...props }) => (
  <CheckboxContainer className={className}>
    <HiddenCheckbox
      type="checkbox"
      checked={checked}
      onChange={onChange}
      value={label}
      name={label}
      id={`custom-checkbox-${id}`}
      {...props}
    />
    <StyledCheckbox checked={checked} onChange={onChange}>
      <Icon viewBox="0 0 24 24">
        <polyline points="20 6 9 17 4 12" />
      </Icon>
    </StyledCheckbox>
  </CheckboxContainer>
);

export const VerticalCheckbox = ({ checked, onChange, id, label, disabled, ...props }) => {
  return (
    <>
      <LabelWrap htmlFor={`custom-checkbox-${id}`} disabled={disabled}>
        <Checkbox checked={checked} onChange={onChange} id={id} label={label} {...props} />
        <Span>{label}</Span>
      </LabelWrap>
    </>
  );
};
